import type { ViewFilterModifier } from "@regrello/graphql-api";

export type RegrelloFilterDefinition_DateStringValue_ExactValueType = {
  type: "exactDateString";
  dateString: string | null;
};
/**
 * A type that describes the ways in which a __date-string__ value can be filtered. It differs from
 * `RegrelloFilterDefinition_DateValue` in that it compares against date fields that are stored as
 * `date` columns in the database, as opposed to `timestamp` columns.
 */

export type RegrelloFilterDefinition_DateStringValue = {
  type: "dateString";
  filter:
    | {
        operator: "EQUALS";
        value: RegrelloFilterDefinition_DateStringValue_ExactValueType;
        modifier?: ViewFilterModifier;
      }
    | {
        operator: "LESS_THAN";
        value: RegrelloFilterDefinition_DateStringValue_ExactValueType;
        modifier?: ViewFilterModifier;
      }
    | {
        operator: "GREATER_THAN";
        value: RegrelloFilterDefinition_DateStringValue_ExactValueType;
        modifier?: ViewFilterModifier;
      };
};

export const regrelloFilterOperators_DateStringValue: Record<
  RegrelloFilterDefinition_DateStringValue["filter"]["operator"],
  true
> = {
  EQUALS: true,
  GREATER_THAN: true,
  LESS_THAN: true,
};

export function getRegrelloDefaultFilterDefinitionDateStringValue(): RegrelloFilterDefinition_DateStringValue {
  return {
    type: "dateString",
    filter: {
      operator: "EQUALS",
      value: {
        type: "exactDateString",
        dateString: null,
      },
    },
  };
}
